// Types d'activité — clé alignée avec l'admin (badminton-club-eragny-admin/src/pages/Creneaux.jsx).
export const TYPE_META = {
  jeu_libre:            { icon: '🏸', label: 'Jeu libre' },
  entrainement:         { icon: '🎯', label: 'Entraînement' },
  interclub:            { icon: '⚔️', label: 'Interclub' },
  cours_individuel:     { icon: '👤', label: 'Cours individuel' },
  jeu_libre_invitation: { icon: '🤝', label: 'Jeu libre avec invitation de clubs' },
};

export const JOURS_ORDER = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];

// Regroupe une liste de créneaux par jour, dans l'ordre de la semaine.
export function groupByJour(creneaux) {
  const byJour = {};
  creneaux.forEach(c => { (byJour[c.jour] ||= []).push(c); });
  return JOURS_ORDER
    .filter(jour => byJour[jour]?.length)
    .map(jour => ({ jour, items: byJour[jour] }));
}

// Regroupe les créneaux d'une catégorie (adulte/jeunes) par jour.
export function groupCreneauxByJour(creneaux, categorie) {
  return groupByJour(creneaux.filter(c => c.categorie === categorie));
}

const PlanningCreneaux = ({ jours }) => (
  <div className="overflow-hidden rounded-2xl border border-stone-100 shadow-card divide-y divide-stone-100">
    {jours.map(({ jour, items }) => (
      <div key={jour} className="flex flex-col sm:flex-row">
        <div className="sm:w-40 shrink-0 flex items-center px-5 py-4" style={{ background: 'var(--gradient-brand)' }}>
          <p className="font-bold text-white text-sm">{jour}</p>
        </div>
        <div className="flex-1 divide-y divide-stone-50 bg-white">
          {items.map(item => {
            // Une activité au type inconnu/manquant n'apporte rien à afficher — on l'ignore
            // plutôt que de laisser un tiret vide (ex: créneau créé sans activité renseignée).
            const activites = (item.activites || []).filter(a => TYPE_META[a.type_creneau]);
            if (!activites.length) return null;
            return (
              <div key={item.id} className="flex flex-col sm:flex-row sm:items-start gap-1 sm:gap-6 px-5 py-3.5">
                <p className="sm:w-32 shrink-0 text-sm font-semibold text-stone-700 tabular-nums sm:pt-px">{item.horaire}</p>
                <div className="space-y-1.5">
                  {activites.map((act, i) => {
                    const meta = TYPE_META[act.type_creneau];
                    return (
                      <p key={i} className="text-sm text-stone-600 flex items-center gap-2">
                        <span className="shrink-0">{meta.icon}</span>
                        <span>{meta.label}{act.specificite ? ` ${act.specificite}` : ''}</span>
                      </p>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    ))}
  </div>
);

export default PlanningCreneaux;
